// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.properties.deactivate.RentalManagerUserPropertyDeactivateWebApiHandler

import type { UseMutationOptions } from '@zg-rentals/react-query5';
import { useMutation } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import {
  RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing,
  RentalManagerUserPropertyDeactivateWebApiHandler_leases,
} from '@zg-rentals/ts-rental-manager-api-client';

import type {
  DeactivateListingRequestDto,
  DeactivateListingResponseDto,
  ListingAlias,
} from '@zg-rentals/ts-rental-manager-api-client';

interface LeasesParams {
  listingAlias: ListingAlias;
  type: string;
  value: boolean;
}

export interface RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Args {
  postData: DeactivateListingRequestDto;
}

export type RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Options = UseMutationOptions<
  DeactivateListingResponseDto,
  unknown,
  RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Args
>;

export const useRentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing = (
  options: Omit<RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing_Args) =>
      RentalManagerUserPropertyDeactivateWebApiHandler_deactivateListing(args.postData),
  });
};

export interface RentalManagerUserPropertyDeactivateWebApiHandler_leases_Args {
  getParams: LeasesParams;
}

export type RentalManagerUserPropertyDeactivateWebApiHandler_leases_Options = UseMutationOptions<
  void,
  unknown,
  RentalManagerUserPropertyDeactivateWebApiHandler_leases_Args
>;

/**
 * Save leases survey response. Types: haveSignedLease, uploadSignedLease, haveLeaseAgreement, uploadUnsignedLease, createLease
 */
export const useRentalManagerUserPropertyDeactivateWebApiHandler_leases = (
  options: Omit<RentalManagerUserPropertyDeactivateWebApiHandler_leases_Options, 'mutationFn'> = {},
) => {
  return useMutation({
    ...tsClientOptions.mutationOptions,
    ...options,
    mutationFn: (args: RentalManagerUserPropertyDeactivateWebApiHandler_leases_Args) =>
      RentalManagerUserPropertyDeactivateWebApiHandler_leases(args.getParams),
  });
};
